<mat-menu #organizationMenu="matMenu" class="org-switch-menu" xPosition="before" yPosition="below">
  <div class="org-menu-context" (click)="$event.stopPropagation()">
    <span>Organization Context</span>
    <strong>{{ activeOrganizationName || 'Organization' }}</strong>
    <small *ngIf="isActingAsOrganization">Acting from {{ homeOrganizationName || 'home organization' }}</small>
    <div class="org-menu-context-actions">
      <a [routerLink]="organizationCenterRoute" mat-button>
        Org Center
      </a>
      <a [routerLink]="activeOrganizationSettingsRoute" mat-button>
        Org Settings
      </a>
    </div>
  </div>
  <div class="org-menu-search" (click)="$event.stopPropagation()">
    <mat-icon>search</mat-icon>
    <input
      #organizationSearchInput
      [value]="organizationSearch"
      (input)="updateOrganizationSearch(organizationSearchInput.value)"
      (keydown)="$event.stopPropagation()"
      placeholder="Search organizations"
      type="text">
  </div>
  <button
    *ngFor="let membership of filteredOrganizationMemberships"
    (click)="switchOrganization(membership.OrganizationId)"
    [disabled]="membership.OrganizationId === activeOrganizationId || isSwitchingOrganization"
    mat-menu-item>
    <mat-spinner *ngIf="isOrganizationSwitching(membership.OrganizationId)" class="org-switch-spinner" diameter="18"></mat-spinner>
    <mat-icon *ngIf="!isOrganizationSwitching(membership.OrganizationId)">{{ membership.OrganizationId === activeOrganizationId ? 'radio_button_checked' : 'business' }}</mat-icon>
    <span>{{ membership.OrganizationName || membership.OrganizationId }}</span>
  </button>
  <div *ngIf="filteredOrganizationMemberships.length === 0" class="org-menu-empty">No organizations found</div>
</mat-menu>

<div *ngIf="layoutService.showHeader && showTenantContextBar" class="tenant-context-bar">
  <div class="tenant-context-left">
    <mat-icon>business</mat-icon>
    <a [routerLink]="activeOrganizationWorkspaceRoute" class="tenant-context-label">
      {{ activeOrganizationName || 'Organization' }}
    </a>
    <span class="tenant-context-summary">{{ tenantContextSummary }}</span>
  </div>

  <div class="tenant-context-actions">
    <button [matMenuTriggerFor]="organizationMenu" mat-button type="button">
      <mat-spinner *ngIf="isSwitchingOrganization" class="tenant-action-spinner" diameter="16"></mat-spinner>
      Switch Organization
    </button>
    <a [routerLink]="activeOrganizationSettingsRoute" mat-button>
      Org Settings
    </a>
    <a [routerLink]="['/platform-settings/audit']" mat-button>
      Audit Trail
    </a>
    <a [routerLink]="['/platform-settings/worker-nodes']" mat-button>
      Worker Nodes
    </a>
    <button
      *ngIf="isActingAsOrganization"
      (click)="switchOrganization(homeOrganizationId)"
      [disabled]="isSwitchingOrganization"
      class="tenant-context-return"
      mat-button
      type="button">
      Return to {{ homeOrganizationName || 'home org' }}
    </button>
  </div>
</div>

<div *ngIf="layoutService.showHeader" class="toolbar w-full px-gutter" fxLayout="row" fxLayoutAlign="start center" vexContainer>
  <button (click)="openSidenav()" [fxHide]="!mobileQuery" mat-icon-button type="button" [attr.data-cy]="'Burger Menu'">
    <mat-icon [icIcon]="icMenu"></mat-icon>
  </button>

  <a *ngIf="isVerticalLayout$ | async" [routerLink]="['/onboard']" class="ltr:mr-4 rtl:ml-4 block" fxLayout="row" fxLayoutAlign="start center">
    <!-- <img class="w-8 select-none" src="assets/img/demo/logo.svg">
    <h1 [fxHide]="mobileQuery" class="title ltr:pl-4 rtl:pr-4 m-0 select-none">VEX</h1> -->
    <img [src]="imageUrl$" loading="lazy" decoding="async" class="w-48 select-none">
  </a>

  <button *ngIf="isHorizontalLayout$ | async" [fxHide]="mobileQuery" [matMenuTriggerFor]="addNewMenu" color="primary" mat-raised-button type="button">Quick Actions
  </button>

  <mat-menu #addNewMenu="matMenu" [overlapTrigger]="false" xPosition="after" yPosition="below">
    <button mat-menu-item>
      <mat-icon [icIcon]="icBallot"></mat-icon>
      <span>Create Catalog</span>
    </button>

    <button mat-menu-item>
      <mat-icon [icIcon]="icUpload"></mat-icon>
      <span>Launch Catalog</span>
    </button>

    <button mat-menu-item>
      <mat-icon [icIcon]="icBr"></mat-icon>
      <span>Sync</span>
    </button>
  </mat-menu>

  <mat-menu #documentMenu="matMenu">
    <button mat-menu-item>
      <mat-icon [icIcon]="icDescription"></mat-icon>
      <span>Add Quote</span>
    </button>

    <button mat-menu-item>
      <mat-icon [icIcon]="icAssignment"></mat-icon>
      <span>Add Invoice</span>
    </button>

    <button mat-menu-item>
      <mat-icon [icIcon]="icReceipt"></mat-icon>
      <span>Add Receipt</span>
    </button>
  </mat-menu>

  <!-- <div #megaMenuOriginRef class="ltr:ml-2 rtl:mr-2">
    <button *ngIf="isHorizontalLayout$ | async"
            [fxHide]="mobileQuery"
            (click)="openMegaMenu(megaMenuOriginRef)"
            color="primary"
            mat-button
            type="button">MEGA MENU
      <ic-icon [icon]="icArrowDropDown" class="ltr:-mr-1 rtl:-ml-1" inline="true"></ic-icon>
    </button>
  </div> -->


  <div *ngIf="(isVerticalLayout$ | async) && isNavbarInToolbar$ | async" [fxHide]="mobileQuery" class="px-gutter" fxFlex="none" fxLayout="row" fxLayoutAlign="start center">
    <vex-navigation-item *ngFor="let item of navigationItems" [item]="item"></vex-navigation-item>
  </div>

  <span fxFlex></span>

  <div class="-mx-1 flex items-center">
     <div class="px-1">
      <button (click)="openGlobalSearch()" mat-icon-button type="button">
        <mat-icon [icIcon]="icSearch" style="font-size: 22px"></mat-icon>
      </button>
    </div>
    <div class="px-1" *ngIf="canOpenGlobalConsole">
      <button (click)="openGlobalConsole()" mat-icon-button type="button"
        matTooltip="Global Console" aria-label="Open Global Console">
        <mat-icon [icIcon]="faTerminal" aria-hidden="true"></mat-icon>
      </button>
    </div>
    <div class="px-1">
      <button (click)="openGlobalKumobot()" mat-icon-button type="button">
        <mat-icon [icIcon]="icAssistant"></mat-icon>
      </button>
    </div>
    <div class="px-1">
      <vex-toolbar-notifications></vex-toolbar-notifications>
    </div>
    <!--
    <div class="px-1">
      <button (click)="openQuickpanel()" mat-icon-button type="button">
        <mat-icon [icIcon]="icBookmarks"></mat-icon>
      </button>
    </div>

    <div class="px-1">
      <button [matMenuTriggerFor]="languageMenu" mat-icon-button type="button">
        <mat-icon [icIcon]="emojioneUS"></mat-icon>
      </button>
    </div> -->

    <div class="px-1">
      <vex-toolbar-user></vex-toolbar-user>
    </div>

    <!-- <mat-menu #languageMenu="matMenu" overlapTrigger="false" xPosition="before" yPosition="below">
      <button mat-menu-item>
        <mat-icon [icIcon]="emojioneUS"></mat-icon>
        <span>English</span>
      </button>

      <button mat-menu-item>
        <mat-icon [icIcon]="emojioneDE"></mat-icon>
        <span>German</span>
      </button>
    </mat-menu> -->
  </div>
</div>

<vex-navigation *ngIf="layoutService.showHeader && (isVerticalLayout$ | async) && isNavbarBelowToolbar$ | async" [fxHide]="mobileQuery">
</vex-navigation>
